import React, {useEffect, useState} from "react";
import {Button, Password, Spacer, Title,Alert, CheckBox} from "@dspworkplace/ui";
import {useForm} from "react-hook-form";
import { getUserId, useAuth, getEmail} from "../../../Auth";
import toast from "../../../components/Toasts/toast";
import { validatePassword, validateObjectNull, validatePasswordBooleanObject } from "../../../patterns";
import { PasswordErrorValidate } from "../../../components/Password/PasswordErrorValidate";

const App = () => {
    const {api} = useAuth();
    const {register, handleSubmit, getValues, errors, watch} = useForm();
    const { password, confirmPassword } = getValues();
    const [status,setStatus] = useState('loaded');
    const [oldPasswordsArr,setOldPasswordsArr] = useState([]);
    const [validation, setValidation] = useState(validateObjectNull);
    const [password1, setPassword1] = useState('');
    const [confirmPassword1, setConfirmPassword1] = useState(""); 
    const disabledSaveBtn = watch('terminateAllSession');
    
    const onSubmit = data => {
        setStatus('submitting');
        if((!data.password || !data.confirmPassword) || data.password != data.confirmPassword){
            setStatus('error');
            return false;
        }

        const param = {
            "key": "id",
            "value": getUserId(),
            "password": data.password,
            "isChangePassword": false,
            "terminateAllSession": data.terminateAllSession,
        };

        api.post('/api/user/update_password/web', param,{
            cache: {
                ignoreCache: true
            }
        }).then(
            response => {
                if (response.data.success) {
                    toast({
                        type: 'success',
                        title: 'New password saved with success',
                        useClose:true,
                        timeout: false
                    })
                    setStatus('loaded')
                    localStorage.setItem("isResetPassword",'false');
                } else {
                    let messageTxt = (response.data?.message) ? response.data?.message : 'There was some error to update the password, try again latter.'; 
                    toast({
                        type: "Error",
                        title: "Error",
                        content: messageTxt
                    });
                    setStatus('loaded')
                }

            },
            error => {
                toast({
                    type: 'Error',
                    title: 'Error',
                    content: 'There was some error to update the password, try again latter.'
                })
                setStatus('loaded')
            }
        )
    }

    const getOldPasswords = async () => {
        const params = {
            "actions": {
                "response": {
                    "User": {
                        "find": {
                            "get": "user",
                            "id": getUserId(),
                            "includes": {
                                "0": "id",
                                "2": "oldPasswords",
                            }
                        }
                    }
                }
            }
        };
        let response = await api.post('/api/lazy/manage/data', params);
        setOldPasswordsArr(response.data.data.user.oldPasswords);
    };

    useEffect(() => {
        getOldPasswords();
    }, []);

    const handleChangeNewPassword = (e) => {
        let password= e.target.value;
        setPassword1(password);
        if (e.target.value.length == 0) {
            setValidation(validateObjectNull);
        } else {
            setValidation(validatePasswordBooleanObject(password, getEmail(), oldPasswordsArr, confirmPassword1));
        }
    };

    const handleChange = (e) => {
        let confirmPassword = e.target.value;
        setConfirmPassword1(confirmPassword);
        if (e.target.value.length > 0) {
            setValidation(validatePasswordBooleanObject(password1, getEmail(), oldPasswordsArr, confirmPassword));
        }
    };
    
    return (
        <Spacer bottom={10} id='password'>
            <Title>Change Password</Title>
            <Spacer bottom={5}/>
            {status === 'error' &&
                <Alert.Error
                    content={'Are differences between the passwords typed'}
                    style={{width:340}}
                />
            }
            <form onSubmit={handleSubmit(onSubmit)}>
                <Password
                    name='password'
                    label='New Password'
                    ref={register({
                        required: true,
                        validate: (value) => {
                            if (value) {
                                return Object.values(validation).every((value) => value === null || value === false);
                            }
                        }
                    })}
                    onChange={(e) => handleChangeNewPassword(e)}
                    error={
                        errors.password &&
                        errors.password.message
                    }
                    valid={!errors.password && password && password.length > 0}
                />
                <Spacer top={3}/>
                <Password
                    name='confirmPassword'
                    label='Confirm Password'
                    help={<PasswordErrorValidate validation={validation} showValidateUsernameAndLast6Password={true} confirmPassword={true}/>}
                    ref={register({
                        required: true,
                        validate: (value) => {
                            if (value) {
                                return Object.values(validation).every((value) => value === null || value === false);
                            }
                        }
                    })}
                    onChange={(e) => handleChange(e)}
                    error={
                        errors.confirmPassword &&
                        errors.confirmPassword.message
                    }
                    valid={!errors.confirmPassword && confirmPassword && confirmPassword.length > 0}
                />
                <Spacer top={3}>
                    <CheckBox
                        name='terminateAllSession'
                        ref={register}
                        style={{float:'right'}}
                        options={[{label:'Forcing a password will terminate all active sessions.',value:true}]}
                        defaultValues={false}
                    />
                </Spacer>
                <Spacer bottom={5} />
                <Button type='primary' disabled={status === 'submitting' || !disabledSaveBtn ? true : false}>{status === 'submitting' ? 'Saving Data...'  : 'Save'}</Button>
            </form>
        </Spacer>
    )
}

export default App;
